import catagories1 from '../assets/images/catagories/portfolio.jpg'
import catagories2 from '../assets/images/catagories/conversation.jpg'
import catagories3 from '../assets/images/catagories/business.jpg'
import catagories4 from '../assets/images/catagories/community.jpg'

import client1 from '../assets/images/client/01.jpg'
import client2 from '../assets/images/client/02.jpg'
import client3 from '../assets/images/client/03.jpg'
import client4 from '../assets/images/client/04.jpg'
import client5 from '../assets/images/client/05.jpg'

import partner1 from '../assets/images/client/spotify.svg'
import partner2 from '../assets/images/client/shopify.svg'
import partner3 from '../assets/images/client/paypal.svg'
import partner4 from '../assets/images/client/lenovo.svg'
import partner5 from '../assets/images/client/google.svg'
import partner6 from '../assets/images/client/amazon.svg'

import team1 from '../assets/images/team/siva.png'
import team2 from '../assets/images/team/manjunath.png'
import team3 from '../assets/images/team/03.jpg'
import team4 from '../assets/images/team/04.jpg'
import team5 from '../assets/images/team/05.jpg'
import team6 from '../assets/images/team/06.jpg'
import team7 from '../assets/images/team/07.jpg'
import team8 from '../assets/images/team/08.jpg'

import podcast1 from '../assets/images/podcasts/applepodcast.png'
import podcast2 from '../assets/images/podcasts/spotigy.png'
import podcast3 from '../assets/images/podcasts/substack.png'
import podcast4 from '../assets/images/podcasts/youtube.png'

import cases1 from '../assets/images/blog/03.jpg'
import cases2 from '../assets/images/blog/05.jpg'
import cases3 from '../assets/images/blog/06.jpg'
import cases4 from '../assets/images/blog/07.jpg'
import cases5 from '../assets/images/blog/08.jpg'
import cases6 from '../assets/images/blog/09.jpg'
import cases7 from '../assets/images/blog/10.jpg'
import cases8 from '../assets/images/blog/11.jpg'
import cases9 from '../assets/images/blog/12.jpg'

import { LuRuler, TfiLayersAlt, FiAirplay, LiaRulerCombinedSolid, BiBullseye, LuUser2, BsFonts, FiHeart,FiDribbble, FaBehance,FaLinkedin, FaFacebookF, FaInstagram, FaTwitter, FiMail, FaRegFile,AiOutlineQuestionCircle, LiaFileInvoiceSolid, FiSettings, FiYoutube} from '../assets/icons/vander'
import { FaApple } from 'react-icons/fa6'

export const catagories = [
    {
        image:catagories1,
        title:'Portfolio'
    },
    {
        image:catagories2,
        title:'Conversation'
    },
    {
        image:catagories3,
        title:'Business'
    },
    {
        image:catagories4,
        title:'Community'
    },
]

export const accordionData = [
    {
        id:1,
        icon:LuRuler,
        desc:'There are many variations of Faff about only a quid blower I don’t want no agro bleeding chimney pot burke tosser cras nice one boot fanny.! passages of Lorem Ipsum available, but the majority have suffered alteration in some form.',
        id1: "entity-setup",
        title: "Entity Setup",
        shortDescription: "Get your business off the ground quickly with our hassle-free entity registration.",
        overview: "Starting strong begins with setting up the right entity. We simplify the process — from structure selection to filings — to make it fast and smooth.",
        offerings: [
          "Business structure advisory",
          "Document preparation and filing",
          "Incorporation registration",
          "PAN, TAN, GST registrations"
        ],
        whyItMatters: "Choosing the wrong entity type or missing registrations can cause costly delays. Our team ensures full legal compliance from day one, giving you a solid foundation for future growth.",
        challenges: [
          { problem: "Confusing entity choices", solution: "Expert advisory on best-fit structures" },
          { problem: "Document complexity", solution: "End-to-end filing and setup support" }
        ],
        faqs: [
          { q: "How long does entity setup take?", a: "Usually 7-10 business days depending on approvals." },
          { q: "Can you help with international setups?", a: "Yes, we support both domestic and cross-border entity formations." }
        ],
        relatedServices: ["Licenses & Permits", "Bank Account Opening"]
    },
    {
        id:2,
        icon:LuRuler,
        desc:'There are many variations of Faff about only a quid blower I don’t want no agro bleeding chimney pot burke tosser cras nice one boot fanny.! passages of Lorem Ipsum available, but the majority have suffered alteration in some form.',
        id1: "licenses-permits",
        title: "Licenses & Permits",
        shortDescription: "Secure necessary licenses and permits to operate legally and confidently.",
        overview: "We help you navigate the regulatory maze by identifying, applying for, and securing all required licenses and permits for your business.",
        offerings: [
          "License requirement analysis",
          "Application preparation and filing",
          "Permit renewals and updates"
        ],
        whyItMatters: "Operating without the right licenses can lead to fines or shutdowns. We ensure full regulatory compliance from the start.",
        challenges: [
          { problem: "Unclear licensing requirements", solution: "Comprehensive regulatory research and advisory" },
          { problem: "Application delays", solution: "End-to-end filing support with authorities" }
        ],
        faqs: [
          { q: "What types of licenses do you help with?", a: "We assist across industries: manufacturing, services, retail, and more." },
          { q: "How long does licensing take?", a: "Depends on industry and region — typically 2–6 weeks." }
        ],
        relatedServices: ["Entity Setup", "Compliance"]
    },
    {
        id:3,
        icon:LuRuler,
        title:'Easy to customize',
        desc:'There are many variations of Faff about only a quid blower I don’t want no agro bleeding chimney pot burke tosser cras nice one boot fanny.! passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
]
export const feature = [
    {
      id: "entity-setup",
      icon:LuRuler,
      title: "Entity Setup",
      shortDescription: "Get your business off the ground quickly with our hassle-free entity registration.",
      overview: "Starting strong begins with setting up the right entity. We simplify the process — from structure selection to filings — to make it fast and smooth.",
      offerings: [
        "Business structure advisory",
        "Document preparation and filing",
        "Incorporation registration",
        "PAN, TAN, GST registrations"
      ],
      whyItMatters: "Choosing the wrong entity type or missing registrations can cause costly delays. Our team ensures full legal compliance from day one, giving you a solid foundation for future growth.",
      challenges: [
        { problem: "Confusing entity choices", solution: "Expert advisory on best-fit structures" },
        { problem: "Document complexity", solution: "End-to-end filing and setup support" }
      ],
      faqs: [
        { q: "How long does entity setup take?", a: "Usually 7-10 business days depending on approvals." },
        { q: "Can you help with international setups?", a: "Yes, we support both domestic and cross-border entity formations." }
      ],
      relatedServices: ["Licenses & Permits", "Bank Account Opening"]
    },
  
    {
      id: "licenses-permits",
      icon:LuRuler,
      title: "Licenses & Permits",
      shortDescription: "Secure necessary licenses and permits to operate legally and confidently.",
      overview: "We help you navigate the regulatory maze by identifying, applying for, and securing all required licenses and permits for your business.",
      offerings: [
        "License requirement analysis",
        "Application preparation and filing",
        "Permit renewals and updates"
      ],
      whyItMatters: "Operating without the right licenses can lead to fines or shutdowns. We ensure full regulatory compliance from the start.",
      challenges: [
        { problem: "Unclear licensing requirements", solution: "Comprehensive regulatory research and advisory" },
        { problem: "Application delays", solution: "End-to-end filing support with authorities" }
      ],
      faqs: [
        { q: "What types of licenses do you help with?", a: "We assist across industries: manufacturing, services, retail, and more." },
        { q: "How long does licensing take?", a: "Depends on industry and region — typically 2–6 weeks." }
      ],
      relatedServices: ["Entity Setup", "Compliance"]
    },
  
    {
      id: "bank-account-opening",
      icon:LuRuler,
      title: "Bank Account Opening",
      shortDescription: "Simplify business banking with expert assistance.",
      overview: "Opening a business bank account can be tricky, especially cross-border. We make it simple, fast, and secure.",
      offerings: [
        "Bank selection advisory",
        "Documentation preparation",
        "KYC compliance assistance",
        "Account activation tracking"
      ],
      whyItMatters: "Bank accounts are critical for financial operations. We remove friction so you can focus on running your business.",
      challenges: [
        { problem: "Account approval delays", solution: "Pre-verified documentation and liaison with banks" },
        { problem: "Unclear KYC needs", solution: "Guided checklist and documentation support" }
      ],
      faqs: [
        { q: "Can you assist with multi-currency accounts?", a: "Yes, we support domestic and international banking setups." }
      ],
      relatedServices: ["Entity Setup", "Payment Facilitation"]
    },
  
    {
      id: "audit",
      icon:LuRuler,
      title: "Audit",
      shortDescription: "Ensure financial transparency and build trust with stakeholders.",
      overview: "We deliver rigorous, efficient audits to verify your financials, identify risks, and strengthen credibility.",
      offerings: [
        "Statutory audits",
        "Internal audits",
        "Special audits",
        "Audit readiness support"
      ],
      whyItMatters: "A clean audit helps secure investments, meet legal obligations, and inspire stakeholder trust.",
      challenges: [
        { problem: "Audit delays", solution: "Proactive documentation and planning support" },
        { problem: "Compliance gaps", solution: "Internal review and rectification guidance" }
      ],
      faqs: [
        { q: "Do you conduct remote audits?", a: "Yes, we offer both onsite and remote audit services." }
      ],
      relatedServices: ["Tax", "Compliance"]
    },
  
    {
      id: "tax",
      icon:LuRuler,
      title: "Tax",
      shortDescription: "Navigate complex tax regulations with confidence.",
      overview: "From filings to strategic planning, we manage your taxes with precision and foresight to minimize risks and costs.",
      offerings: [
        "Corporate and individual tax filings",
        "Tax advisory and optimization",
        "GST and indirect tax compliance",
        "Transfer pricing guidance"
      ],
      whyItMatters: "Poor tax planning can impact profitability. We keep you compliant and optimized year-round.",
      challenges: [
        { problem: "Missed filing deadlines", solution: "Automated reminders and proactive filing support" },
        { problem: "Overpayment of taxes", solution: "Strategic tax planning and exemptions advisory" }
      ],
      faqs: [
        { q: "Can you help with cross-border taxation?", a: "Yes, we specialize in international and transfer pricing matters." }
      ],
      relatedServices: ["Audit", "Outsourced Accounting & Finance"]
    },
  
    {
      id: "outsourced-accounting",
      icon:LuRuler,
      title: "Outsourced Accounting & Finance",
      shortDescription: "Professional accounting and finance support tailored to your needs.",
      overview: "We manage your day-to-day accounting and financial reporting so you can focus on running and growing your business.",
      offerings: [
        "Bookkeeping and ledger maintenance",
        "Financial reporting and analysis",
        "Budgeting and forecasting",
        "Accounts payable and receivable management"
      ],
      whyItMatters: "Outsourcing accounting gives you financial clarity, cost savings, and expertise without building a full internal team.",
      challenges: [
        { problem: "Inconsistent financial reports", solution: "Standardized monthly reporting and review" },
        { problem: "Resource-heavy accounting tasks", solution: "Full-service back-office accounting support" }
      ],
      faqs: [
        { q: "Can you integrate with our accounting software?", a: "Yes, we support major platforms like QuickBooks, Xero, Zoho, and more." }
      ],
      relatedServices: ["Tax", "CFO"]
    },
  
    {
      id: "payroll-processing",
      icon:LuRuler,
      title: "Payroll Processing",
      shortDescription: "Reliable, timely, and compliant payroll solutions.",
      overview: "Our payroll services ensure your employees are paid accurately and on time, while maintaining full compliance with tax and labor laws.",
      offerings: [
        "Monthly payroll processing",
        "Payslip generation",
        "Statutory deductions and filings",
        "Employee reimbursements and benefits administration"
      ],
      whyItMatters: "Smooth payroll builds trust with employees and protects your company from compliance risks.",
      challenges: [
        { problem: "Payroll errors", solution: "Automated and verified payroll processing" },
        { problem: "Non-compliance penalties", solution: "Timely tax filings and accurate record-keeping" }
      ],
      faqs: [
        { q: "Do you handle international payroll?", a: "Yes, we assist with both domestic and expatriate payrolls." }
      ],
      relatedServices: ["HR Administration", "Compliance"]
    },
  
    {
      id: "compliance",
      icon:LuRuler,
      title: "Compliance",
      shortDescription: "Ensure your business stays ahead of legal and regulatory requirements.",
      overview: "We handle all compliance tasks — statutory, secretarial, and regulatory — to keep your company safe from risks and penalties.",
      offerings: [
        "Company law compliance",
        "Labour law and environmental compliance",
        "Annual return filings",
        "Compliance audits"
      ],
      whyItMatters: "Compliance failures can cost you time, money, and reputation. We prevent that with proactive management.",
      challenges: [
        { problem: "Missed regulatory deadlines", solution: "Full compliance calendar and monitoring" },
        { problem: "Complex legal requirements", solution: "Expert advisory and documentation support" }
      ],
      faqs: [
        { q: "Can you help with industry-specific compliance?", a: "Yes, we tailor compliance services to your industry regulations." }
      ],
      relatedServices: ["Audit", "Legal"]
    },
  
    {
      id: "hr-administration",
      icon:LuRuler,
      title: "HR Administration",
      shortDescription: "Comprehensive HR solutions to support your growing team.",
      overview: "We simplify your HR processes so you can attract, manage, and retain top talent effectively and compliantly.",
      offerings: [
        "Employee onboarding and exit management",
        "HR policy creation and updates",
        "Leave and attendance tracking",
        "Employee benefits administration"
      ],
      whyItMatters: "Strong HR systems boost employee satisfaction and reduce legal risks.",
      challenges: [
        { problem: "Disorganized employee records", solution: "Centralized HR management systems" },
        { problem: "Unclear HR policies", solution: "Tailored handbook and compliance advisory" }
      ],
      faqs: [
        { q: "Do you help with setting up HR systems?", a: "Yes, we assist with software selection and implementation." }
      ],
      relatedServices: ["Payroll Processing", "Compliance"]
    },
  
    {
      id: "reporting-analysis",
      icon:LuRuler,
      title: "Reporting & Analysis",
      shortDescription: "Unlock insights from your business data.",
      overview: "We provide meaningful financial reports and customized dashboards to help you track performance and make informed decisions.",
      offerings: [
        "Management reports",
        "Budget vs. actual analysis",
        "Custom dashboards",
        "Variance and trend analysis"
      ],
      whyItMatters: "Clear data visualization improves decision-making speed and quality.",
      challenges: [
        { problem: "Slow reporting cycles", solution: "Automated monthly management reporting" },
        { problem: "Hard-to-interpret numbers", solution: "Clear visuals and executive summaries" }
      ],
      faqs: [
        { q: "Can you customize KPIs based on our goals?", a: "Absolutely, we design reporting tailored to your strategic goals." }
      ],
      relatedServices: ["CFO", "Outsourced Accounting & Finance"]
    },
  
    {
      id: "cfo",
      icon:LuRuler,
      title: "CFO",
      shortDescription: "Strategic financial leadership, when you need it.",
      overview: "Our outsourced CFO services bring strategic finance, forecasting, and fundraising expertise to help scale your business.",
      offerings: [
        "Strategic financial planning",
        "Cash flow management",
        "Fundraising and investor relations",
        "Board and management reporting"
      ],
      whyItMatters: "A seasoned CFO guides better decisions, financial health, and faster growth without full-time overheads.",
      challenges: [
        { problem: "Lack of financial strategy", solution: "CFO-driven budgeting and financial modeling" },
        { problem: "Difficult investor conversations", solution: "Professional investor reporting and insights" }
      ],
      faqs: [
        { q: "Can I engage a part-time CFO?", a: "Yes, we offer flexible CFO engagement models." }
      ],
      relatedServices: ["Reporting & Analysis", "Advisory & Consulting"]
    },
  
    {
      id: "advisory-consulting",
      icon:LuRuler,
      title: "Advisory & Consulting",
      shortDescription: "Tailored guidance to accelerate your business growth.",
      overview: "We provide strategic advisory across business expansion, restructuring, and optimization to help you navigate challenges and seize opportunities.",
      offerings: [
        "Business growth strategy",
        "Operational improvement",
        "Market entry consulting",
        "M&A advisory"
      ],
      whyItMatters: "Having the right advisors at the right time can dramatically change your growth trajectory.",
      challenges: [
        { problem: "Stalled growth", solution: "Strategic repositioning and operational scaling" },
        { problem: "Complex new market entry", solution: "End-to-end market strategy support" }
      ],
      faqs: [
        { q: "Do you provide startup advisory?", a: "Yes, we advise startups and high-growth companies." }
      ],
      relatedServices: ["CFO", "Legal"]
    },
  
    {
      id: "payment-facilitation",
      icon:LuRuler,
      title: "Payment Facilitation",
      shortDescription: "Simplify local and cross-border payments.",
      overview: "We help you manage seamless payments to employees, vendors, and partners across jurisdictions.",
      offerings: [
        "Payment gateway setup",
        "Vendor payment solutions",
        "Cross-border remittance advisory",
        "Currency conversion support"
      ],
      whyItMatters: "Faster, compliant payments keep your business running and relationships strong.",
      challenges: [
        { problem: "Delayed payments", solution: "Streamlined payment systems and monitoring" },
        { problem: "Currency conversion losses", solution: "FX optimization support" }
      ],
      faqs: [
        { q: "Do you integrate with ERP systems?", a: "Yes, we integrate with ERPs and financial platforms." }
      ],
      relatedServices: ["Bank Account Opening", "Outsourced Accounting"]
    },
  
    {
      id: "registered-office",
      icon:LuRuler,
      title: "Registered Office/Virtual Space Support",
      shortDescription: "Establish your legal and virtual presence with ease.",
      overview: "We provide official addresses and virtual office services to meet regulatory requirements and establish credibility.",
      offerings: [
        "Registered office address",
        "Mail handling and forwarding",
        "Virtual receptionist and meeting rooms"
      ],
      whyItMatters: "A legitimate address boosts credibility and ensures compliance.",
      challenges: [
        { problem: "No local presence", solution: "Registered address and office representation" },
        { problem: "Mail mismanagement", solution: "Secure mail handling and forwarding" }
      ],
      faqs: [
        { q: "Can I receive parcels and notices at the virtual office?", a: "Yes, all official correspondence is accepted and forwarded." }
      ],
      relatedServices: ["Entity Setup", "Compliance"]
    },
  
    {
      id: "nominee-directorship",
      icon:LuRuler,
      title: "Nominee Directorship",
      shortDescription: "Protect your privacy and meet regulatory requirements.",
      overview: "We offer nominee director services to satisfy legal requirements while protecting your ownership details.",
      offerings: [
        "Nominee director appointment",
        "Director service agreements",
        "Annual regulatory filings"
      ],
      whyItMatters: "Nominee directors maintain confidentiality and ensure compliance for foreign or private owners.",
      challenges: [
        { problem: "Ownership disclosure risks", solution: "Confidential nominee arrangements" },
        { problem: "Lack of local representation", solution: "Professional, compliant nominees" }
      ],
      faqs: [
        { q: "Is nominee directorship legal?", a: "Yes, when structured properly with full disclosures where required." }
      ],
      relatedServices: ["Entity Setup", "Legal"]
    },
  
    {
      id: "legal",
      icon:LuRuler,
      title: "Legal",
      shortDescription: "Comprehensive legal support for growing businesses.",
      overview: "Our legal team assists with contracts, governance, regulatory matters, and dispute resolution to keep your operations secure and compliant.",
      offerings: [
        "Contract drafting and negotiation",
        "Company secretarial services",
        "Legal due diligence",
        "Dispute resolution support"
      ],
      whyItMatters: "Solid legal frameworks reduce risk and protect your business interests.",
      challenges: [
        { problem: "Contract loopholes", solution: "Meticulous drafting and review" },
        { problem: "Regulatory non-compliance", solution: "Ongoing legal advisory" }
      ],
      faqs: [
        { q: "Can you handle cross-border legal issues?", a: "Yes, we specialize in both local and international business law." }
      ],
      relatedServices: ["Compliance", "Advisory & Consulting"]
    }
  
  
  ];
  export const services_india_evaluation = [
    {
    id: "india-readiness-assessment",
    icon: LuRuler,
    title: "India Readiness Assessment",
    shortDescription: "We assess how prepared your organization is — strategically, operationally, and financially — to enter the Indian market, based on your industry, size, and goals.",
    overview: "We evaluate your business’ readiness for Indian entry — including legal, operational, and financial aspects — helping you make an informed, risk-aware decision.",
    offerings: ["Organizational capability analysis", "Regulatory risk review", "Operational readiness scoring", "Go/no-go decision support"],
    whyItMatters: "Jumping into India without proper readiness can result in cost overruns, missed deadlines, and strategic missteps. Our framework reduces surprises and sharpens your go-to-market confidence.",
    challenges: [{
    problem: "Lack of India-specific insight",
    solution: "Customized readiness benchmarks and advisory"
    }, {
    problem: "Internal misalignment",
    solution: "Stakeholder interviews and consensus-building tools"
    }],
    faqs: [{
    q: "How do you assess readiness?",
    a: "We use a proprietary framework covering strategic, legal, and operational dimensions."
    }, {
    q: "Is this suitable for startups?",
    a: "Yes, we tailor our assessment based on your company size and stage."
    }],
    relatedServices: ["Entry SWOT Analysis", "Executive Alignment Workshops"]
    },
    {
    id: "industry-market-fit",
    icon: LuRuler,
    title: "Industry Market Fit",
    shortDescription: "Analyze how your products or services align with Indian demand, pricing sensitivity, and customer expectations across key regions.",
    overview: "We map your offerings to India’s complex demand landscape, assessing resonance with local preferences, pricing thresholds, and buying behavior.",
    offerings: ["Competitive landscape assessment", "Regional demand mapping", "Price benchmarking", "Product adaptation advisory"],
    whyItMatters: "A product that thrives elsewhere might flop in India if not tuned to local realities. We reduce this risk with clear, data-driven insights.",
    challenges: [{
    problem: "Mismatch in customer needs",
    solution: "In-depth consumer research and feedback loops"
    }, {
    problem: "Ineffective pricing strategy",
    solution: "Local pricing benchmarks and elasticity analysis"
    }],
    faqs: [{
    q: "How is demand assessed?",
    a: "We combine secondary research with expert interviews and public datasets."
    }, {
    q: "Do you offer regional breakouts?",
    a: "Yes, insights can be segmented by metro, tier-2, or state-level trends."
    }],
    relatedServices: ["On-Ground Visit Planning", "Expansion Roadmap & Budgeting"]
    },
    {
    id: "global-benchmarking",
    icon: LuRuler,
    title: "Global Benchmarking",
    shortDescription: "Compare India with other potential markets in terms of cost structures, talent availability, logistics, and ease of doing business.",
    overview: "We benchmark India against alternative markets — helping you weigh trade-offs in costs, scalability, incentives, and risk.",
    offerings: ["Side-by-side country comparisons", "Talent pool and wage data", "Incentive program summaries", "Business climate scorecards"],
    whyItMatters: "India may not always be the best choice. Benchmarking gives you confidence that you’re investing in the right market — or adjusting your timing wisely.",
    challenges: [{
    problem: "Biased market assumptions",
    solution: "Objective, data-backed scoring system"
    }, {
    problem: "Incomplete cost comparison",
    solution: "Standardized cost metrics across geographies"
    }],
    faqs: [{
    q: "Do you cover other South Asian markets?",
    a: "Yes — we also benchmark Bangladesh, Vietnam, Indonesia, and others."
    }],
    relatedServices: ["India Readiness Assessment", "Business Structure Advisory"]
    },
    {
    id: "entry-swot-analysis",
    icon: LuRuler,
    title: "Entry SWOT Analysis",
    shortDescription: "Get a tailored Strengths, Weaknesses, Opportunities, and Threats evaluation based on your business model and India’s economic ecosystem.",
    overview: "We analyze your company’s strengths and blind spots in the context of Indian opportunities, regulatory barriers, and competitive pressures.",
    offerings: ["Tailored SWOT deep-dive", "India regulatory risk mapping", "Opportunity scan by sector", "Strategic recommendations"],
    whyItMatters: "A SWOT customized to the Indian context highlights leverage points and watch-outs you might otherwise miss — helping you shape your entry plan.",
    challenges: [{
    problem: "Superficial SWOT templates",
    solution: "Sector- and geography-specific analysis"
    }, {
    problem: "Overlooking local threats",
    solution: "Scenario planning with competitive simulations"
    }],
    faqs: [{
    q: "Is this different from a global SWOT?",
    a: "Yes — this is tailored specifically to India’s ecosystem."
    }],
    relatedServices: ["Industry Market Fit", "Executive Alignment Workshops"]
    },
    {
    id: "business-structure-advisory",
    icon: LuRuler,
    title: "Business Structure Advisory",
    shortDescription: "We guide you in selecting the right entry model — whether subsidiary, branch office, or local partnership — based on your goals and risk profile.",
    overview: "We evaluate different legal structures suitable for your India entry — such as wholly-owned subsidiaries, LLPs, branch offices, or joint ventures — and help you choose the best fit.",
    offerings: ["Structure feasibility comparison", "Ownership and control assessment", "Tax and compliance implications", "Custom structure recommendations"],
    whyItMatters: "The right structure balances control, risk, tax efficiency, and regulatory ease. A poor choice can lock you into unnecessary complications.",
    challenges: [{
    problem: "Unclear regulatory paths",
    solution: "Guidance on entry pathways under FEMA, RBI, and MCA norms"
    }, {
    problem: "Mismatch with business goals",
    solution: "Structure selection based on your ownership, control, and liability preferences"
    }],
    faqs: [{
    q: "Can we convert later if needed?",
    a: "In some cases yes, but it’s best to start with the right structure to avoid delays and costs."
    }],
    relatedServices: ["Compliance Landscape Overview", "India Readiness Assessment"]
    },
    {
    id: "compliance-landscape-overview",
    icon: LuRuler,
    title: "Compliance Landscape Overview",
    shortDescription: "Understand the key legal and regulatory frameworks — including foreign ownership rules, tax regimes, and sector-specific constraints.",
    overview: "We decode India’s complex compliance environment — including company law, foreign direct investment (FDI) norms, labor codes, and tax requirements — tailored to your sector.",
    offerings: ["FDI and foreign ownership norms", "Company law and board structure requirements", "Sector-specific compliance mapping", "Initial risk checklist"],
    whyItMatters: "Compliance in India is layered and evolving. Knowing what applies to you — and what doesn’t — is key to a smooth setup.",
    challenges: [{
    problem: "Overlooking regulatory nuances",
    solution: "Customized compliance maps by sector and entry route"
    }, {
    problem: "Fragmented legal landscape",
    solution: "Integrated view of central, state, and local mandates"
    }],
    faqs: [{
    q: "Does compliance vary by region?",
    a: "Yes — especially in labor, environment, and incentive policies."
    }],
    relatedServices: ["Business Structure Advisory", "Audit & Legal"]
    },
    {
    id: "expansion-roadmap-budgeting",
    icon: LuRuler,
    title: "Expansion Roadmap & Budgeting",
    shortDescription: "Receive a sample 12–18 month roadmap with major milestones, cost estimates, and resource planning guidance.",
    overview: "We help you visualize your first 12–18 months in India — mapping out costs, timelines, dependencies, and potential bottlenecks so you can plan with confidence.",
    offerings: ["Customized roadmap by function (legal, hiring, infra)", "Setup cost estimations", "Hiring and ramp-up planning", "Risk-adjusted milestone mapping"],
    whyItMatters: "Without a structured plan, India entry can turn into reactive firefighting. Our roadmaps enable strategic control from Day 1.",
    challenges: [{
    problem: "Budget overruns",
    solution: "Pre-estimates with local benchmarks and buffer planning"
    }, {
    problem: "Lack of coordinated milestones",
    solution: "Cross-functional roadmap development and visualization"
    }],
    faqs: [{
    q: "Do you offer investor-friendly versions?",
    a: "Yes, we can tailor the roadmap for board or investor presentations."
    }],
    relatedServices: ["India Readiness Assessment", "On-Ground Visit Planning"]
    },
    {
    id: "executive-alignment-workshops",
    icon: LuRuler,
    title: "Executive Alignment Workshops",
    shortDescription: "Facilitate alignment across your leadership team through interactive sessions that unpack the opportunity and set realistic expectations.",
    overview: "We conduct interactive workshops to align internal leadership around India’s opportunity, risk-reward profile, and execution expectations.",
    offerings: ["Opportunity sizing briefings", "Leadership expectation calibration", "Risk-tolerance framing", "Action planning and next steps"],
    whyItMatters: "India entry fails when leadership isn’t aligned. These workshops get everyone on the same page and moving with clarity.",
    challenges: [{
    problem: "Internal disagreements",
    solution: "Facilitated discussions to surface concerns and align priorities"
    }, {
    problem: "Over-optimism or skepticism",
    solution: "Data-driven framing and scenario modeling"
    }],
    faqs: [{
    q: "Who should attend?",
    a: "Typically your CXO team, business heads, and India project leads."
    }],
    relatedServices: ["Entry SWOT Analysis", "Leadership Immersion Sessions"]
    },
    {
    id: "on-ground-visit-planning",
    icon: LuRuler,
    title: "On-Ground Visit Planning",
    shortDescription: "When you’re ready to engage firsthand, we organize curated business visits, local facility tours, and meetings with relevant ecosystem partners.",
    overview: "We organize immersive in-country visits for your leadership or ops teams — including factory tours, real estate scouting, and partner meetings.",
    offerings: ["Visit itinerary design", "Partner and vendor meeting facilitation", "Factory and office tours", "Local logistics and interpretation"],
    whyItMatters: "There’s no substitute for seeing things firsthand. Our curated visits provide clarity and local intelligence you can’t get from afar.",
    challenges: [{
    problem: "Unfocused travel plans",
    solution: "Agenda designed around specific business objectives"
    }, {
    problem: "Language and cultural gaps",
    solution: "On-site interpretation and cross-cultural advisory"
    }],
    faqs: [{
    q: "Can this be combined with regulatory meetings?",
    a: "Yes, we can arrange meetings with SEZ, STPI, or state-level authorities."
    }],
    relatedServices: ["Industry Market Fit", "Expansion Roadmap & Budgeting"]
    },
    {
    id: "leadership-immersion-sessions",
    icon: LuRuler,
    title: "Leadership Immersion Sessions",
    shortDescription: "Curated experiences for business leaders to explore how India’s traditions in leadership, ethics, and resilience can inform strategy, culture, and long-term decision-making.",
    overview: "We create reflective experiences for your leadership team that explore Indian traditions in ethics, long-term thinking, and resilient decision-making.",
    offerings: ["Sessions with Indian business philosophers", "Immersive experiences in heritage locations", "Leadership roundtables on Indian ethos", "East-meets-West strategic dialogues"],
    whyItMatters: "To succeed in India long-term, it helps to understand the country not just economically — but culturally, philosophically, and spiritually.",
    challenges: [{
    problem: "Western-centric leadership paradigms",
    solution: "Exposure to India’s distinctive values and decision frameworks"
    }, {
    problem: "Short-termism in planning",
    solution: "Facilitated reflection and resilience thinking from Indian models"
    }],
    faqs: [{
    q: "Is this just cultural training?",
    a: "No — it’s about building deep strategic empathy and long-view thinking."
    }],
    relatedServices: ["Executive Alignment Workshops", "India Readiness Assessment"]
    }
    ];

    export const services_india_entry = [
      {
      overview: "We help you select the right entry structure for India — balancing regulatory ease, tax implications, control, and scalability.",
      offerings: ["Legal entity comparison (Pvt Ltd, LLP, Branch, etc.)", "Tax impact modeling", "FDI compliance considerations", "Customized recommendations"],
      whyItMatters: "Choosing the wrong structure can limit future growth, create tax inefficiencies, or invite regulatory challenges. We help you make the right call.",
      challenges: [{
      problem: "Conflicting stakeholder preferences",
      solution: "Clear decision matrix and scenario planning"
      }, {
      problem: "Limited India-specific knowledge",
      solution: "Expert-led advisory with global context"
      }],
      faqs: [{
      q: "Can we restructure later?",
      a: "It’s possible, but costly. Better to get it right from the start."
      }],
      relatedServices: ["Incorporation-Registration", "RBI-FEMA-Compliance"],
      id: "Entity-Structure-Advisory",
      icon: "LuRuler",
      title: "Entity Structure Advisory",
      shortDescription: "We help you choose the right legal structure — Pvt. Ltd., LLP, or branch — based on tax treatment, liability, and long-term scalability."
      },
      {
      overview: "We handle all necessary filings and formalities to register your Indian entity and make it legally operational.",
      offerings: ["Company name approval via MCA", "Digital signature & DIN processing", "MoA/AoA drafting and filing", "PAN, TAN, GST, and ESIC/EPFO registration"],
      whyItMatters: "Proper incorporation is the legal foundation of your Indian operations — don’t let errors delay your launch.",
      challenges: [{
      problem: "Government portal errors",
      solution: "We manage retries and workarounds efficiently"
      }, {
      problem: "Complex form filling",
      solution: "Guided document collection and submission"
      }],
      faqs: [{
      q: "How long does it take to register?",
      a: "Typically 7–10 working days after documentation is ready."
      }],
      relatedServices: ["Entity-Structure-Advisory", "Foundational-Docs-Liaison"],
      id: "Incorporation-Registration",
      icon: LuRuler,
      title: "Incorporation & Registration",
      shortDescription: "We handle all required filings, including company formation, PAN, TAN, and GST, so you can operate legally from day one."
      },
      {
      overview: "We ensure your setup and funding comply with India’s foreign exchange laws — a must for foreign-owned entities.",
      offerings: ["FDI route selection (auto vs approval)", "FC-GPR and FC-TRS filings", "Banker liaison for inward remittance", "Ongoing FEMA/RBI monitoring"],
      whyItMatters: "FEMA compliance errors can result in heavy fines. We prevent that with bulletproof processes and proactive filings.",
      challenges: [{
      problem: "Ambiguity in FEMA rules",
      solution: "We interpret and align with updated circulars"
      }, {
      problem: "Delayed filings",
      solution: "Deadline tracking and auto-alerts"
      }],
      faqs: [{
      q: "Do we need approval from RBI?",
      a: "In most sectors, no — we operate under the automatic route."
      }],
      relatedServices: ["Incorporation-Registration", "Banking-Remittance-Setup"],
      id: "RBI-FEMA-Compliance",
      icon: LuRuler,
      title: "RBI/FEMA Compliance",
      shortDescription: "For foreign-owned entities, we ensure full compliance with RBI and FEMA rules during setup and in ongoing operations."
      },
      {
      overview: "We prepare core documents (MoA, AoA, board resolutions, etc.) and handle submissions with Indian regulators.",
      offerings: ["Charter document drafting", "Board and shareholder resolutions", "Notarization and apostille advisory", "Registrar and department liaison"],
      whyItMatters: "Well-drafted foundational documents reduce future friction with authorities, banks, or partners.",
      challenges: [{
      problem: "Lack of legal familiarity",
      solution: "We simplify with pre-vetted templates and explanations"
      }, {
      problem: "Missing approvals",
      solution: "We coordinate with ROC and local government bodies"
      }],
      faqs: [{
      q: "Can we use our global MoA template?",
      a: "India has specific format requirements — we’ll adapt yours accordingly."
      }],
      relatedServices: ["Entity-Structure-Advisory", "Legal Support"],
      id: "Foundational-Docs-Liaison",
      icon: LuRuler,
      title: "Foundational Docs & Liaison",
      shortDescription: "We draft statutory documents and liaise with Indian authorities to secure timely approvals and clearances."
      },
      {
      overview: "We open compliant INR and foreign currency accounts and guide your first funding transfers under FEMA.",
      offerings: ["Bank account opening support", "FIRC and KYC coordination", "Fund flow structuring (equity, loans, services)", "Banker introductions and documentation"],
      whyItMatters: "Funding your Indian operations requires proper banking and RBI filings. We streamline the whole process.",
      challenges: [{
      problem: "Bank delays",
      solution: "We coordinate directly with bank RM teams"
      }, {
      problem: "Incorrect remittance coding",
      solution: "Verified inward remittance instructions"
      }],
      faqs: [{
      q: "Can we use our global bank?",
      a: "No — you’ll need a registered Indian bank account."
      }],
      relatedServices: ["RBI-FEMA-Compliance", "CFO Services"],
      id: "Banking-Remittance-Setup",
      icon: LuRuler,
      title: "Banking & Remittance Setup",
      shortDescription: "We assist in opening compliant bank accounts and help structure secure, regulatory-aligned cross-border fund flows."
      },
      {
      overview: "We set up compliant HR systems — from payroll and benefits to contracts and leave tracking.",
      offerings: ["Employment contract templates", "Payroll system configuration", "ESIC/EPFO registration", "Leave and attendance systems"],
      whyItMatters: "Poor HR compliance can create serious penalties. We help you get it right from employee #1.",
      challenges: [{
      problem: "Lack of India-specific rules",
      solution: "Templates aligned to Indian labor laws"
      }, {
      problem: "Disparate HR tools",
      solution: "Unified setup with integrations"
      }],
      faqs: [{
      q: "Do you support global tools?",
      a: "Yes, we integrate with Deel, Darwinbox, Zoho, and others."
      }],
      relatedServices: ["Cultural-Onboarding-for-Teams", "Payroll"],
      id: "Payrol-HR-Systems",
      icon: LuRuler,
      title: "Payroll & HR Systems",
      shortDescription: "We set up contracts, payroll systems, and benefits that comply with Indian labor law while aligning with global standards."
      },
      {
      overview: "We help you find, evaluate, and secure workspace — whether virtual, co-working, leased offices, or light industrial facilities.",
      offerings: ["Needs assessment and location advisory", "Shortlisting and due diligence", "Lease negotiation and legal vetting", "Facilities setup referrals"],
      whyItMatters: "Your workspace impacts operations, compliance, and perception. We ensure your first base in India is the right one.",
      challenges: [{
      problem: "Unfamiliar real estate norms",
      solution: "Advisory from local experts on lease and compliance"
      }, {
      problem: "Hidden costs",
      solution: "Transparent budgeting and facility-level comparisons"
      }],
      faqs: [{
      q: "Do you help with flexible spaces?",
      a: "Yes — we support WeWork, Awfis, IndiQube, and others."
      }],
      relatedServices: ["Incorporation-Registration", "Technology-Setup-Integration"],
      id: "Office-Space-Scouting",
      icon: LuRuler,
      title: "Office Space Scouting",
      shortDescription: "Whether you need virtual, co-working, or leased office space, we help you choose the right fit for your operations and growth plan."
      },
      {
      overview: "We implement essential business software — accounting, payroll, HR, CRM — and integrate it with your global stack.",
      offerings: ["Tool selection based on India needs", "Cloud setup and user configuration", "Integration with global platforms (ERP, HRIS)", "Training and documentation"],
      whyItMatters: "A misaligned tech stack leads to confusion and duplication. We streamline it for clarity and scale.",
      challenges: [{
      problem: "Local incompatibilities",
      solution: "India-ready apps pre-vetted for your domain"
      }, {
      problem: "Scattered vendor choices",
      solution: "One-stop implementation support"
      }],
      faqs: [{
      q: "Do you support Zoho and Tally?",
      a: "Yes — and also FreshBooks, QuickBooks, Xero, etc."
      }],
      relatedServices: ["Payroll", "CFO Services"],
      id: "Technology-Setup-Integration",
      icon: LuRuler,
      title: "Technology Setup & Integration",
      shortDescription: "We implement your core tech stack — accounting, HR, communication tools — and ensure smooth integration with global systems."
      },
      {
      overview: "We help craft your India brand strategy, engage with press, and make your market debut memorable.",
      offerings: ["Brand messaging localization", "Press release and media outreach", "PR calendar and event planning", "Influencer and content strategy"],
      whyItMatters: "India is a noisy market. A tailored brand approach builds early traction and stakeholder trust.",
      challenges: [{
      problem: "Global-first messaging gaps",
      solution: "India-specific messaging refinement"
      }, {
      problem: "Media disconnect",
      solution: "Local PR team coordination and pitch crafting"
      }],
      faqs: [{
      q: "Do you help with launch events?",
      a: "Yes, including logistics and media coordination."
      }],
      relatedServices: ["Cultural-Onboarding-for-Teams", "Leadership-Immersion-Session"],
      id: "Brand-PR-Guidance",
      icon: LuRuler,
      title: "Brand & PR Guidance",
      shortDescription: "For firms seeking visibility in India, we offer support in localizing your brand, engaging the media, and launching with impact."
      },
      {
      overview: "We design orientation sessions for global and Indian teams to bridge cultural gaps and align expectations from day one.",
      offerings: ["Cross-cultural communication workshops", "Indian workplace norms and etiquette", "Leadership and hierarchy alignment", "Conflict resolution coaching"],
      whyItMatters: "Misunderstandings around communication or hierarchy can derail teams early. We prevent that with empathy-led training.",
      challenges: [{
      problem: "Frustration from differing expectations",
      solution: "Early education and behavioral insights"
      }, {
      problem: "Poor team cohesion",
      solution: "Ongoing cultural coaching and retrospectives"
      }],
      faqs: [{
      q: "Is this for expats only?",
      a: "No — both Indian and global teams benefit from mutual context-building."
      }],
      relatedServices: ["Leadership-Immersion-Session", "Payroll & HR Systems"],
      id: "Cultural-Onboarding-for-Teams",
      icon: LuRuler,
      title: "Cultural Onboarding for Teams",
      shortDescription: "We help global leaders and Indian teams understand each other’s work styles, communication norms, and expectations — creating a smoother, more aligned start."
      },
      {
      overview: "In this 90-minute session, we apply insights from the Bhagavad Gita to improve clarity, courage, and detachment in business leadership.",
      offerings: ["Guided workshop with case studies", "Decision frameworks from Gita shlokas", "Interactive Q&A", "Follow-up toolkit for leaders"],
      whyItMatters: "Leaders in India respect philosophical depth. This session sets a thoughtful tone for your entry.",
      challenges: [{
      problem: "Overwhelm in complexity",
      solution: "Clarity through timeless frameworks"
      }, {
      problem: "Fear of failure or backlash",
      solution: "Gita’s lens on purpose and action"
      }],
      faqs: [{
      q: "Is this religious?",
      a: "No — it is philosophical and secular in business framing."
      }],
      relatedServices: ["Leadership-Immersion-Session", "Executive Alignment Workshops"],
      id: "Gita-for-Decision-Making",
      icon: LuRuler,
      title: "Gita for Decision-Making (Workshop)",
      shortDescription: "A 90-minute session applying principles from the Bhagavad Gita to business leadership — ideal for founders and executives navigating complexity and scale."
      },
      {
      overview: "Through a half-day immersive experience, we explore India’s approach to resilience, ethics, duty, and growth through curated conversations and local exposure.",
      offerings: ["Facilitated leadership circles", "Exposure to Indian entrepreneurial philosophy", "Ethical decision-making modules", "Cultural excursions (optional)"],
      whyItMatters: "To succeed long-term, leadership must resonate with India’s ethos. This session builds that alignment.",
      challenges: [{
      problem: "Short-term mindset",
      solution: "Long-view planning inspired by Indian philosophy"
      }, {
      problem: "Disconnect from local context",
      solution: "Immersive empathy-building through curated interactions"
      }],
      faqs: [{
      q: "Do we need prior India experience?",
      a: "Not at all — this session is a warm, guided entry."
      }],
      relatedServices: ["Cultural-Onboarding-for-Teams", "Gita-for-Decision-Making"],
      id: "Leadership-Immersion-Session",
      icon: LuRuler,
      title: "Leadership Immersion Session",
      shortDescription: "Curated experiences for senior teams to explore India’s leadership values — from long-termism to resilience — and integrate them into strategy and culture."
      }
      ];
      export const services_india_growth = [
        {
        overview: "We manage your monthly, quarterly, and annual compliance calendar — including ROC filings, GST returns, and labor reports — so you can focus on your business.",
        offerings: ["ROC, MCA, and RBI filings", "GST returns and reconciliations", "Professional tax, PF/ESIC compliance", "Annual return preparation"],
        whyItMatters: "Compliance failures invite fines, scrutiny, and reputational risk. Our systemized approach keeps you audit-ready and penalty-free.",
        challenges: [{
        problem: "Missed deadlines",
        solution: "Compliance calendar and auto-reminders"
        }, {
        problem: "Inconsistent filings",
        solution: "Standardized templates and checks"
        }],
        faqs: [{
        q: "Do you manage everything end-to-end?",
        a: "Yes — including preparation, review, filing, and tracking."
        }],
        relatedServices: ["Bookkeeping-Payroll", "Tax-Advisory-Optimization"],
        id: "Ongoing-Compliance-Management",
        icon: LuRuler,
        title: "Ongoing Compliance Management",
        shortDescription: "We handle routine tax filings, secretarial work, and statutory reporting so you stay fully compliant year-round."
        },
        {
        overview: "We assess your tax footprint and optimize your India presence — ensuring you’re tax-efficient, compliant, and future-ready.",
        offerings: ["Direct and indirect tax advisory", "Transfer pricing and BEPS support", "GST planning and optimization", "Advance tax computation"],
        whyItMatters: "Smart tax planning improves profitability and reduces risk exposure — especially across borders.",
        challenges: [{
        problem: "Overpaying taxes",
        solution: "Review and apply eligible deductions/exemptions"
        }, {
        problem: "Cross-border complexity",
        solution: "Transfer pricing and treaty guidance"
        }],
        faqs: [{
        q: "Do you support global tax teams?",
        a: "Yes — we provide India-specific guidance to integrate globally."
        }],
        relatedServices: ["Ongoing-Compliance-Management", "Financial-Reporting-CFO"],
        id: "Tax-Advisory-Optimization",
        icon: LuRuler,
        title: "Tax Advisory & Optimization",
        shortDescription: "We ensure you're not leaving money on the table — through proactive tax planning and risk mitigation."
        },
        {
        overview: "Our fractional CFOs provide financial clarity through dashboards, board packs, and strategic input on local spending and growth.",
        offerings: ["Monthly MIS and variance reports", "Budget vs actual tracking", "Cash flow forecasting", "Board presentation support"],
        whyItMatters: "Without visibility into Indian operations, HQ teams can’t steer growth. Our CFOs bring control and foresight.",
        challenges: [{
        problem: "Disconnected reporting",
        solution: "Unified format aligned with global HQ"
        }, {
        problem: "Surprise overruns",
        solution: "Forecasting and early-warning mechanisms"
        }],
        faqs: [{
        q: "Can we customize dashboards?",
        a: "Yes — fully tailored to your KPIs and board needs."
        }],
        relatedServices: ["Performance-Dashboards", "Bookkeeping-Payroll"],
        id: "Financial-Reporting-CFO",
        icon: LuRuler,
        title: "Financial Reporting & CFO Services",
        shortDescription: "Our virtual CFOs offer reporting, budgeting, and board-ready insights to support your India operations."
        },
        {
        overview: "We provide reliable, timely bookkeeping and payroll services — ensuring accurate ledgers and smooth employee payouts.",
        offerings: ["Cloud-based bookkeeping", "Bank reconciliation and AR/AP management", "Payroll computation and disbursement", "Payslip and Form 16 generation"],
        whyItMatters: "Clean books and timely payroll build operational trust — both internally and externally.",
        challenges: [{
        problem: "Errors in payouts",
        solution: "Pre-run validations and approvals"
        }, {
        problem: "Manual ledger updates",
        solution: "Automated and cloud-synced accounting"
        }],
        faqs: [{
        q: "Do you integrate with Zoho, Xero, or QuickBooks?",
        a: "Yes, we support all major platforms."
        }],
        relatedServices: ["HR-Admin-Benefits", "Financial-Reporting-CFO"],
        id: "Bookkeeping-Payroll",
        icon: LuRuler,
        title: "Bookkeeping & Payroll",
        shortDescription: "From ledgers to payslips, we run the financial back-office so you can focus on business growth."
        },
        {
        overview: "We turn your financial and operational data into real-time dashboards — helping HQ monitor India metrics with clarity.",
        offerings: ["Custom dashboard development", "Integration with ERP, HRMS, CRM systems", "KPI definition and tracking", "Automated monthly reporting"],
        whyItMatters: "Dashboards eliminate blind spots. You see what’s working and what’s not — instantly.",
        challenges: [{
        problem: "Data overload",
        solution: "Curated, role-specific dashboards"
        }, {
        problem: "Disparate systems",
        solution: "Integrated pipelines and visualization"
        }],
        faqs: [{
        q: "Can dashboards be shared with investors?",
        a: "Yes — we provide clean, presentation-ready views."
        }],
        relatedServices: ["Financial-Reporting-CFO", "Bookkeeping-Payroll"],
        id: "Performance-Dashboards",
        icon: LuRuler,
        title: "Performance Dashboards",
        shortDescription: "We build live dashboards tracking KPIs across operations, finance, HR, and compliance in India."
        },
        {
        overview: "Our legal team handles contract reviews, employment agreements, NDAs, and day-to-day legal questions for your India entity.",
        offerings: ["Contract drafting and review", "Localization of global templates", "On-call legal advisory", "Vendor and employee dispute support"],
        whyItMatters: "Having local legal clarity prevents future escalations and aligns with India’s unique requirements.",
        challenges: [{
        problem: "Mismatch in legal language",
        solution: "Localization and India-specific clauses"
        }, {
        problem: "Unclear legal risk",
        solution: "Proactive legal health checks"
        }],
        faqs: [{
        q: "Can you act as our India legal point of contact?",
        a: "Yes — through a retainer or on-call model."
        }],
        relatedServices: ["HR-Admin-Benefits", "Ongoing-Compliance-Management"],
        id: "Legal-Support-Contracts",
        icon: LuRuler,
        title: "Legal Support & Contracts",
        shortDescription: "We draft, review, and localize contracts and offer on-call legal advisory for your India unit."
        },
        {
        overview: "We run your India HR back office — including employee records, benefits processing, and compliance with labor regulations.",
        offerings: ["HR policy and handbook drafting", "Employee database management", "Leave and attendance systems", "Benefits administration (PF, ESIC, gratuity)"],
        whyItMatters: "Strong HR infrastructure improves retention and protects against regulatory risk.",
        challenges: [{
        problem: "Disorganized records",
        solution: "Digitized HR documentation and logs"
        }, {
        problem: "Inconsistent benefits",
        solution: "Standardized, compliant employee packages"
        }],
        faqs: [{
        q: "Do you support hybrid/remote teams?",
        a: "Yes — our systems are flexible and cloud-based."
        }],
        relatedServices: ["Bookkeeping-Payroll", "Legal-Support-Contracts"],
        id: "HR-Admin-Benefits",
        icon: LuRuler,
        title: "HR Admin & Benefits",
        shortDescription: "We manage HR documentation, benefits, and labor compliance to help you build a strong local team."
        },
        {
        overview: "We help you track ESG metrics, structure CSR programs, and publish impact reports aligned with Indian regulations.",
        offerings: ["ESG metric identification and tracking", "CSR spending advisory and execution", "Sustainability reporting (BRSR, GRI, etc.)", "Stakeholder reporting support"],
        whyItMatters: "ESG transparency builds reputation, meets listing norms, and attracts long-term partners.",
        challenges: [{
        problem: "Lack of ESG framework",
        solution: "We define and baseline your ESG roadmap"
        }, {
        problem: "Unstructured CSR spending",
        solution: "Program design with impact tracking"
        }],
        faqs: [{
        q: "Is ESG reporting mandatory in India?",
        a: "For large listed companies, yes — and increasingly expected across the board."
        }],
        relatedServices: ["Legal-Support-Contracts", "Performance-Dashboards"],
        id: "ESG-Impact-Reporting",
        icon: LuRuler,
        title: "ESG & Impact Reporting",
        shortDescription: "We help you track and report ESG metrics and CSR compliance, in line with Indian regulations."
        },
        {
        overview: "We provide internal audits and risk assessments — flagging control gaps, inefficiencies, or regulatory exposures.",
        offerings: ["Internal audit planning and execution", "Risk register and mitigation plans", "Process walkthroughs and testing", "Management letters and follow-ups"],
        whyItMatters: "Audits don’t just catch issues — they build stakeholder trust and governance credibility.",
        challenges: [{
        problem: "Compliance gaps",
        solution: "Systematic checks and follow-up action items"
        }, {
        problem: "Limited internal capacity",
        solution: "We act as your independent audit function"
        }],
        faqs: [{
        q: "Are these audits statutory?",
        a: "No — they’re internal but increasingly expected by boards."
        }],
        relatedServices: ["Ongoing-Compliance-Management", "Financial-Reporting-CFO"],
        id: "Business-Risk-Audit",
        icon: LuRuler,
        title: "Business Risk & Internal Audit",
        shortDescription: "We conduct periodic audits and risk assessments to catch gaps before they become liabilities."
        },
        {
        overview: "We help you expand within India — by advising on pricing, partnerships, local expansion strategy, and channel introductions.",
        offerings: ["India go-to-market refinement", "B2B/B2G partnership matchmaking", "Government incentive navigation", "Regional expansion planning"],
        whyItMatters: "Growth in India depends on the right local allies. We help you find them and succeed with them.",
        challenges: [{
        problem: "Lack of connections",
        solution: "Curated introductions and warm handshakes"
        }, {
        problem: "Unclear regional playbook",
        solution: "Localized expansion guidance"
        }],
        faqs: [{
        q: "Do you support manufacturing partnerships?",
        a: "Yes — across tech, logistics, and industrial supply chains."
        }],
        relatedServices: ["Performance-Dashboards", "ESG-Impact-Reporting"],
        id: "Growth-Advisory-Partnerships",
        icon: LuRuler,
        title: "Growth Advisory & Partnerships",
        shortDescription: "We connect you with customers, vendors, and allies in India — opening new doors and reducing friction."
        },
        {
        id: "Roots-Wings-Immersion",
        icon: LuRuler,
        title: "Roots & Wings Immersion Session",
        shortDescription: "A guided journey exploring India's wisdom and innovation — helping global leaders align growth with grounded values.",
        overview: "This curated session integrates traditional Indian values with modern business foresight. We explore how long-term thinking, resilience, family systems, and entrepreneurship coexist and can shape sustainable global leadership.",
        offerings: ["Immersive workshop on Indian philosophical values in business", "Dialogue on sustainability, leadership, and legacy", "Cross-generational leadership reflections (family-run models)", "Narratives from Indian innovators and rooted thinkers"],
        whyItMatters: "India offers not just a market, but a mindset — where growth is balanced with values. Understanding this can lead to more resilient, purpose-driven organizations.",
        challenges: [{
        problem: "Short-termism in business outlook",
        solution: "Reframing goals with Indian models of sustainability and stewardship"
        }, {
        problem: "Leadership-cultural disconnect",
        solution: "Interactive immersion bridging personal purpose and public success"
        }],
        faqs: [{
        q: "Is this session only for expats?",
        a: "No — it is designed for global leaders and Indian leaders seeking alignment with deeper purpose."
        }, {
        q: "Is it spiritual?",
        a: "It’s secular and values-driven — blending culture, business, and leadership psychology."
        }],
        relatedServices: ["Gita-for-Decision-Making", "Leadership-Immersion-Session"]
        },
        {
        id: "Gita-Strategy-Session",
        icon: LuRuler,
        title: "Gita Strategy Session for Executives",
        shortDescription: "A reflective workshop using the Bhagavad Gita to explore clarity, detachment, and leadership under uncertainty.",
        overview: "In this advanced session, we use insights from the Bhagavad Gita to tackle executive challenges such as scaling responsibly, letting go of ego-driven strategy, and embracing dharma-aligned leadership. It is ideal for growth-stage founders and India-based CXOs.",
        offerings: ["Gita-based strategic frameworks (karma, buddhi, dharma)", "Application to org-building, investor relations, and vision", "Interactive case studies with Gita parallels", "Facilitated self-reflection and discussion"],
        whyItMatters: "Executives leading in India face unique internal and external pressures. Gita-inspired thinking provides timeless clarity in the face of complexity.",
        challenges: [{
        problem: "Decision fatigue and over-control",
        solution: "Clarity through detachment and duty-aligned action"
        }, {
        problem: "Ego-centric leadership behaviors",
        solution: "Gita’s framing of selfless, impact-driven leadership"
        }],
        faqs: [{
        q: "Is this religious?",
        a: "No — it is a secular interpretation of Indian strategic philosophy rooted in the Gita."
        }, {
        q: "Who should attend?",
        a: "CXOs, founders, and senior leaders managing growth and people."
        }],
        relatedServices: ["Roots-Wings-Immersion", "Leadership-Immersion-Session"]
        },
        {
          id: "Cultural-Realignment-India-Teams",
          icon: LuRuler,
          title: "Cultural Realignment for India Teams",
          shortDescription: "We help bridge disconnects between your HQ and India teams — improving collaboration, accountability, and cultural fluency on both sides.",
          overview: "As organizations scale, cultural drift can set in between headquarters and India teams. This session is designed to reset expectations, build mutual respect, and create clear collaboration rituals for long-term success.",
          offerings: [
            "Cross-cultural feedback analysis",
            "Facilitated roundtable discussions",
            "Trust and communication reset exercises",
            "Playbooks for ongoing alignment"
          ],
          whyItMatters: "Even strong teams suffer when intent is lost in translation. Realignment restores clarity, energy, and accountability across geographies.",
          challenges: [
            { problem: "HQ-India misunderstandings", solution: "Guided reflection and realignment facilitation" },
            { problem: "Drop in collaboration quality", solution: "Tools and rhythms for sustained cross-border teamwork" }
          ],
          faqs: [
            { q: "Can this include both India and HQ staff?", a: "Yes — sessions can be hybrid, remote, or in-person." }
          ],
          relatedServices: ["HR-Admin-Benefits", "Roots-Wings-Immersion"]
        },
        {
          id: "Leadership-Reset-Sessions",
          icon: LuRuler,
          title: "Leadership Reset Sessions",
          shortDescription: "Guided sessions for founders or senior managers to reflect, re-anchor values, and align local execution with global purpose.",
          overview: "These confidential sessions offer senior leaders a space to pause, reflect, and course-correct. Using timeless Indian principles blended with modern coaching tools, we help re-establish inner clarity and external alignment.",
          offerings: [
            "Facilitated reflection exercises",
            "Leadership storytelling and purpose work",
            "Decision journaling frameworks",
            "Private coaching and clarity conversations"
          ],
          whyItMatters: "Leadership drift can demotivate teams and blur mission clarity. Resetting leadership mindset ensures your strategy flows from clarity and conviction.",
          challenges: [
            { problem: "Leadership fatigue or drift", solution: "Personalized sessions to reconnect vision and action" },
            { problem: "Scaling misalignment", solution: "Values-based reframing for the next phase of growth" }
          ],
          faqs: [
            { q: "Is this group or one-on-one?", a: "Both options are available based on role and need." }
          ],
          relatedServices: ["Gita-Strategy-Session", "Executive Alignment Workshops"]
        },
        {
          id: "Gita-Based-Decision-Support",
          icon: LuRuler,
          title: "Gita-Based Decision Support",
          shortDescription: "Drawing on the Gita’s timeless leadership principles, we offer sessions to help India or HQ teams regain clarity and cohesion during complex transitions.",
          overview: "These focused sessions apply Bhagavad Gita wisdom to real business challenges — helping teams navigate ambiguity, disagreement, or transitions. We contextualize insights for both Indian and global audiences.",
          offerings: [
            "Real-time strategic facilitation",
            "Values vs ego sorting frameworks",
            "Scenario-based dialogue and reflection",
            "Action plans rooted in clarity and courage"
          ],
          whyItMatters: "When business paths diverge or decisions become emotionally charged, the Gita offers tested clarity. Our sessions convert that into modern team decision tools.",
          challenges: [
            { problem: "Decision gridlock or emotional noise", solution: "Detachment and purpose framing" },
            { problem: "Loss of cohesion in complex moments", solution: "Shared language and principles to re-anchor unity" }
          ],
          faqs: [
            { q: "Do you facilitate for global teams?", a: "Yes — including multicultural and senior executive audiences." }
          ],
          relatedServices: ["Gita-Strategy-Session", "Roots-Wings-Immersion"]
        }
        ];
export const services = [
    {
        icon:LuRuler,
        title:'Entity Setup',
        desc:"Private Limited, LLP, or Branch Office — fully compliant and audit-ready from day one.",
        id: "entity-setup",
        title: "Entity Setup",
        shortDescription: "Get your business off the ground quickly with our hassle-free entity registration.",
        overview: "Starting strong begins with setting up the right entity. We simplify the process — from structure selection to filings — to make it fast and smooth.",
        offerings: [
          "Business structure advisory",
          "Document preparation and filing",
          "Incorporation registration",
          "PAN, TAN, GST registrations"
        ],
        whyItMatters: "Choosing the wrong entity type or missing registrations can cause costly delays. Our team ensures full legal compliance from day one, giving you a solid foundation for future growth.",
        challenges: [
          { problem: "Confusing entity choices", solution: "Expert advisory on best-fit structures" },
          { problem: "Document complexity", solution: "End-to-end filing and setup support" }
        ],
        faqs: [
          { q: "How long does entity setup take?", a: "Usually 7-10 business days depending on approvals." },
          { q: "Can you help with international setups?", a: "Yes, we support both domestic and cross-border entity formations." }
        ],
        relatedServices: ["Licenses & Permits", "Bank Account Opening"]
    },
    {
        icon:TfiLayersAlt,
        title:'Accounting & Compliance',
        desc:"Bookkeeping, GST, Income Tax, ROC filings, cross-border documentation.",
        id: "licenses-permits",
        title: "Licenses & Permits",
        shortDescription: "Secure necessary licenses and permits to operate legally and confidently.",
        overview: "We help you navigate the regulatory maze by identifying, applying for, and securing all required licenses and permits for your business.",
        offerings: [
          "License requirement analysis",
          "Application preparation and filing",
          "Permit renewals and updates"
        ],
        whyItMatters: "Operating without the right licenses can lead to fines or shutdowns. We ensure full regulatory compliance from the start.",
        challenges: [
          { problem: "Unclear licensing requirements", solution: "Comprehensive regulatory research and advisory" },
          { problem: "Application delays", solution: "End-to-end filing support with authorities" }
        ],
        faqs: [
          { q: "What types of licenses do you help with?", a: "We assist across industries: manufacturing, services, retail, and more." },
          { q: "How long does licensing take?", a: "Depends on industry and region — typically 2–6 weeks." }
        ],
        relatedServices: ["Entity Setup", "Compliance"]
    },
    {
        icon:FiAirplay,
        title:'Hiring & HR Ops',
        desc:"Contracts, payroll, employment law compliance, EOR support.",
        id: "bank-account-opening",
        title: "Bank Account Opening",
        shortDescription: "Simplify business banking with expert assistance.",
        overview: "Opening a business bank account can be tricky, especially cross-border. We make it simple, fast, and secure.",
        offerings: [
          "Bank selection advisory",
          "Documentation preparation",
          "KYC compliance assistance",
          "Account activation tracking"
        ],
        whyItMatters: "Bank accounts are critical for financial operations. We remove friction so you can focus on running your business.",
        challenges: [
          { problem: "Account approval delays", solution: "Pre-verified documentation and liaison with banks" },
          { problem: "Unclear KYC needs", solution: "Guided checklist and documentation support" }
        ],
        faqs: [
          { q: "Can you assist with multi-currency accounts?", a: "Yes, we support domestic and international banking setups." }
        ],
        relatedServices: ["Entity Setup", "Payment Facilitation"]
    },
    {
        icon:LiaRulerCombinedSolid,
        title:'Tech + Localization',
        desc:"India-specific onboarding, product tweaks, and data compliance.",
        id: "audit",
        title: "Audit",
        shortDescription: "Ensure financial transparency and build trust with stakeholders.",
        overview: "We deliver rigorous, efficient audits to verify your financials, identify risks, and strengthen credibility.",
        offerings: [
          "Statutory audits",
          "Internal audits",
          "Special audits",
          "Audit readiness support"
        ],
        whyItMatters: "A clean audit helps secure investments, meet legal obligations, and inspire stakeholder trust.",
        challenges: [
          { problem: "Audit delays", solution: "Proactive documentation and planning support" },
          { problem: "Compliance gaps", solution: "Internal review and rectification guidance" }
        ],
        faqs: [
          { q: "Do you conduct remote audits?", a: "Yes, we offer both onsite and remote audit services." }
        ],
        relatedServices: ["Tax", "Compliance"]
    },
    {
        icon:BiBullseye,
        title:'Go-To-Market Support',
        desc:"Industry connections, channel partners, and BD help where needed."
    },
    {
        icon:LuUser2,
        title:'AI Agent Solutions',
        desc:"Deploy AI agents to streamline onboarding, invoice generation, knowledge workflows, and client interaction. Human-led, AI-augmented."
    },
    {
        icon:BsFonts,
        title:'Intercompany Structuring',
        desc:"Simplify revenue flows and documentation between your U.S. and India entities with full tax compliance."
    },
    {
        icon:FiHeart,
        title:'IP Protection in India',
        desc:"Secure your trademarks, copyrights, and patents in India with expert guidance."
    },
    {
        icon:LuUser2,
        title:'Virtual Office & Local Address Services',
        desc:"Maintain a credible Indian presence without needing physical space upfront."
    },
    {
        icon:BsFonts,
        title:'Board & Director Services',
        desc:"Appoint nominee directors or establish an advisory board structure per Indian regulatory norms."
    },
    {
        icon:FiHeart,
        title:'Cross-border Invoicing Support',
        desc:"Ensure your international billing is GST-compliant, properly documented, and optimized for forex management."
    },]

export const clientOneData = [
    {
        image:client1,
        name:'Germany based Subsidiary in Chennai',
        title:'Director',
        desc:'" We thank you sincerely for all your timely & efficient support during critical phases of our business. We count on the professional skill & ethics."'
    },
    {
        image:client2,
        name:'Denmark based Subsidiary in Chennai',
        title:'Director',
        desc:'" Performance of Pioneer One is completely satisfactory. We wish them all the best for their future and looking forward to their continued support. "'
    },
    {
        image:client3,
        name:'Denmark based Subsidiary in Chennai',
        title:'Director',
        desc:'" Since the beginning it has been a pleasure working with your team. Pioneer One is supporting us with good performance. "'
    },
    {
        image:client4,
        name:'Belgium based Subsidiary in Chennai',
        title:'Managing Director – Emerging Markets ',
        desc:'" Your accounting and auditing services has been excellent. Transition to new rules like IFRS16 has been fast and impeccable. Everything is being done with 100% commitment and 100% compliance is being met. "'
    },
    {
        image:client5,
        name:'CI Group',
        title:'Managing director',
        desc:'" As the Managing Director of CI Group with three companies I can confidently say I am enjoying worry free peace of mind about my accounts department functioning 360 degrees perfectly. Pioneer One delivers more than satisfying value for the fee we are paying. "'
    },
]
export const clientFourData = [
  {
      image:client1,
      name:'Venkat R.',
      title:'Bellevue, WA',
      desc:'" I started my day listening to this episode. Calmness is the result . Thank you. I can\'t wait for the next episode!"'
  },
  {
      image:client2,
      name:'Deepa V.',
      title:'Dallas, TX',
      desc:'" Wow, this is quite inspirational! "'
  },
  {
      image:client3,
      name:'Ravishankar R.',
      title:'Amsterdam, Netherlands',
      desc:'" So inspired by this! "'
  },
  {
      image:client4,
      name:'Susheela R.',
      title:'Bengaluru, India ',
      desc:'" Amazing clarity of ideas! "'
  },
]
export const partnerImage = [
    partner1,partner2,partner3,partner4,partner5,partner6
]
export const serviceStages = [
  {
      image:client1,
      name:'Germany based Subsidiary in Chennai',
      title:'India - Evaluation',
      pagelink:"/page-india-evaluation",
      desc:'" We thank you sincerely for all your timely & efficient support during critical phases of our business. We count on the professional skill & ethics."'
  },
  {
    image:client1,
    name:'Germany based Subsidiary in Chennai',
    title:'India - Entry',
    pagelink:"/page-india-entry",
    desc:'" We thank you sincerely for all your timely & efficient support during critical phases of our business. We count on the professional skill & ethics."'
},
{
  image:client1,
  name:'Germany based Subsidiary in Chennai',
  title:'India - Growth',
  pagelink:"/page-india-growth",
  desc:'" We thank you sincerely for all your timely & efficient support during critical phases of our business. We count on the professional skill & ethics."'
}
]
export const landing = [
   'Entity Setup','Accounting & Compliance','Hiring & HR Ops','Tech + Localization','Go-To-Market Support','AI-Agent Solutions'
]
export const footerLinks = [
  {
      image:client1,
      name:'Germany based Subsidiary in Chennai',
      title:'Why India?',
      pagelink:"/page-why-india",
      desc:'" We thank you sincerely for all your timely & efficient support during critical phases of our business. We count on the professional skill & ethics."'
  },
  {
    image:client1,
    name:'Germany based Subsidiary in Chennai',
    title:'About Us',
    pagelink:"/page-about",
    desc:'" We thank you sincerely for all your timely & efficient support during critical phases of our business. We count on the professional skill & ethics."'
},
{
  image:client1,
  name:'Germany based Subsidiary in Chennai',
  title:'AI Labs',
  pagelink:"/page-ai-lab",
  desc:'" We thank you sincerely for all your timely & efficient support during critical phases of our business. We count on the professional skill & ethics."'
},
{
  image:client1,
  name:'Germany based Subsidiary in Chennai',
  title:'Contact',
  pagelink:"/contact",
  desc:'" We thank you sincerely for all your timely & efficient support during critical phases of our business. We count on the professional skill & ethics."'
},
{
  image:client1,
  name:'Germany based Subsidiary in Chennai',
  title:'Terms Policy',
  pagelink:"/page-t&c",
  desc:'" We thank you sincerely for all your timely & efficient support during critical phases of our business. We count on the professional skill & ethics."'
},
{
  image:client1,
  name:'Germany based Subsidiary in Chennai',
  title:'Privacy Policy',
  pagelink:"/page-privacy",
  desc:'" We thank you sincerely for all your timely & efficient support during critical phases of our business. We count on the professional skill & ethics."'
}
]
export const about = [
    'Services','About Us', "Case Studies","AI Labs","Contact",'Terms Policy','Privacy Policy'
 ]
 export const location = [
    'Seattle','Chennai' 
 ]

 export const footerSocial = [
    // {
    //     icon: FiYoutube,
    //     link:'https://youtube.com/pioneerconsultingllp2972'
    // },
    // {
    //     icon: FaLinkedin,
    //     link:'http://linkedin.com/company/13182347'
    // },
    // {
    //     icon: FaFacebookF,
    //     link:'https://www.facebook.com/PioneerOneConsulting/'
    // },
    // {
    //     icon: FaInstagram,
    //     link:'https://www.instagram.com/pioneeroneconsulting/'
    // },
    // {
    //     icon: FaTwitter,
    //     link:'https://twitter.com/PioneerOneLLP'
    // },
    // {
    //     icon: FiMail,
    //     link:'mailto:reach@pioneerone.in'
    // },
 ]


export const footerSocialRAW = [
  {
    icon: FiYoutube,
    link: "https://youtube.com/@RootsandWingsPodcast",
    color: "rgb(255, 0, 0)" // YouTube red
  },
  // {
  //   icon: FaLinkedin,
  //   link: "http://linkedin.com/company/13182347",
  //   color: "rgb(10, 102, 194)" // LinkedIn blue
  // },
  {
    icon: FaFacebookF,
    link: "https://www.facebook.com/people/Roots-and-Wings/61579826168884/",
    color: "rgb(24, 119, 242)" // Facebook blue
  },
  {
    icon: FaInstagram,
    link: "https://www.instagram.com/rootsandwingsindia/",
    color: "rgb(193, 53, 132)" // Instagram gradient anchor (magenta)
  },
  {
    icon: FaTwitter,
    link: "https://twitter.com/indiarootswings",
    color: "rgb(29, 155, 240)" // Twitter blue
  },
  {
    icon: FiMail,
    link: "mailto:contact@pioneeroneglobal.com",
    color: "rgb(109, 109, 109)" // Neutral gray for email
  }
];
export const footerSocialB2B = [
  {
    icon: FiYoutube,
    link: "https://youtube.com/@PioneerOneGlobal",
    color: "rgb(255, 0, 0)" // YouTube red
  },
  {
    icon: FaLinkedin,
    link: "http://linkedin.com/company/13182347",
    color: "rgb(10, 102, 194)" // LinkedIn blue
  },
  {
    icon: FaFacebookF,
    link: "https://facebook.com/people/Bridge-to-Bharath/61579707343176/",
    color: "rgb(24, 119, 242)" // Facebook blue
  },
  {
    icon: FaInstagram,
    link: "https://www.instagram.com/bridgetobharath/",
    color: "rgb(193, 53, 132)" // Instagram gradient anchor (magenta)
  },
  {
    icon: FaTwitter,
    link: "https://twitter.com/bridgetobharath",
    color: "rgb(29, 155, 240)" // Twitter blue
  },
  {
    icon: FiMail,
    link: "mailto:contact@pioneeroneglobal.com",
    color: "rgb(109, 109, 109)" // Neutral gray for email
  }
];

export const footerPodcastRAW = [
  {
      image: podcast1,
      link:'https://podcasts.apple.com/podcast/id1816481804'
  },
  {
      image: podcast2,
      link:'https://open.spotify.com/show/0YDH5AGGr739k0E6TgLee2'
  },
  {
      image: podcast3,
      link:'https://solidcommonground.substack.com'
  }
]
export const footerPodcastB2B = [
  {
      image: podcast1,
      link:'https://podcasts.apple.com/us/podcast/bridge-to-bharath/id1833729345'
  },
  {
      image: podcast2,
      link:'https://open.spotify.com/show/4KAgKZm9WFSaoBz7Fwi3Pu'
  },
  {
    image: podcast4,
    link:'https://www.youtube.com/watch?v=OPOa29fGhPM'
  }
]

export const footerBlogSocial = [
  {
      image: podcast1,
      link:'https://podcasts.apple.com/us/podcast/bridge-to-bharath/id1833729345'
  },
  {
      image: podcast2,
      link:'https://open.spotify.com/show/4KAgKZm9WFSaoBz7Fwi3Pu'
  },
  {
    image: podcast4,
    link:'https://www.youtube.com/watch?v=OPOa29fGhPM'
  }
]

 export const TeamData = [
    {
        image:team1,
        name:'Calvin Carlo',
        position:'Founder',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
    {
        image:team2,
        name:'Martin Sobhe',
        position:'C.E.O.',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
    {
        image:team3,
        name:'Bobby DE',
        position:'Developer',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
    {
        image:team4,
        name:'Cristino Murphy',
        position:'Designer',
        social:['mdi mdi-facebook','mdi mdi-instagram','mdi mdi-twitter','mdi mdi-google-plus','mdi mdi-linkedin']
    },
 ]

 export const teamOne = [
    {
        image:team1,
        name:'Siva Bala Narayanan',
        position:'Founder & CEO, Pioner One Global',
        position2:'Founder & CEO, Minmini Corporation',
        description:"Siva leads Pioneer One Global with a vision to bridge global opportunity and India’s potential. With decades of experience in AI-driven automation and international expansion, he founded POG as a Minmini Corporation initiative inspired by the impactful work of Pioneer One Consulting in India.",
        social:[{icon: 'mdi mdi-linkedin', link: 'https://www.linkedin.com/in/siva-bala-narayanan-234291'}]
    },
    {
        image:team2,
        name:'C. S. Manjunath',
        position:'Strategic Advisor, Pioneer One Global',
        position2: 'Founder & Business Head, Pioneer One Consulting LLP',
        description:"Manjunath brings deep domain expertise in accounting, compliance, and India-entry services. As the founder of Pioneer One India, he serves as a strategic advisor to POG, helping align its mission with ground realities and client success in India.",
        social:[{icon: 'mdi mdi-linkedin', link: 'https://www.linkedin.com/in/manjunath-subramaniam-1755b051'}]
    },
 ]

 export const helpFeature = [
    {
        icon:AiOutlineQuestionCircle,
        iconColor:'text-info h1',
        title:'FAQs',
        desc:'It seems that only fragments of the original text remain in the Lorem Ipsum texts used today.',
        link:'/help-faq'
    },
    {
        icon:LiaFileInvoiceSolid,
        iconColor:'text-danger h1',
        title:'Guides / Support',
        desc:'It seems that only fragments of the original text remain in the Lorem Ipsum texts used today.',
        link:'/help-guides'
    },
    {
        icon:FiSettings,
        iconColor:'text-warning h1',
        title:'Support Request',
        desc:'It seems that only fragments of the original text remain in the Lorem Ipsum texts used today.',
        link:'/help-support'
    },
 ]

 export const faqData = [
    {
        id:1,
        title:'How does it work ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:2,
        title:'Do I need a designer to use leaping ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:3,
        title:'What do I need to do to start selling ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
    {
        id:4,
        title:'What happens when I receive an order ?',
        desc:'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form.'
    },
 ]

 export const guides = [
    {
        title:'Your account',
        feature:[
            'Your profile',
            'Account security',
            'Identification & verifications',
            'Reviews',
            'Superhost status'
        ]
    },
    {
        title:'Getting started',
        feature:[
            'Deciding to purchase',
            'List your space',
            'Landing an experience or adventure',
            'Top uses questions',
        ]
    },
    {
        title:'Your calendar',
        feature:[
            'Pricing & availability',
            'Booking settings',
            'Responding to enquiries & requests',
            'Snoozing or deactivating your listing',
        ]
    },
    {
        title:'Your listings',
        feature:[
            'Updating your listing',
            'Neighbourhoods',
            'Listing photos & photography',
            'leaping Plus',
            'API-connected software'
        ]
    },
    {
        title:'How payouts work',
        feature:[
            'Getting paid',
            'Adding payout info',
            'Your payout status',
            'Donations',
            'Taxes'
        ]
    },
    {
        title:'Your reservations',
        feature:[
            'leaping safely',
            'leaping Experiences and Adventures',
            'Changing a reservation',
            'Cancelling a reservation',
            'Long-term reservations'
        ]
    },
    {
        title:'Reservation help',
        feature:[
            'Help with a reservation or guest',
            'Guest cancellations',
        ]
    },
 ]

 export const casesData = [
    {
        id:"1",
        image:cases1,
        name:'SaaS Company from Berlin',
        title:'Entity Setup',
        background:"A mid-sized SaaS provider with customers across Europe wanted to enter India for both talent and client acquisition.",
        challenge:"No prior presence or infrastructure in India; unclear on incorporation, hiring, and invoicing norms.",
        solution:"POC helped set up a Private Limited Company in under 3 weeks, secured GST registration, opened a local bank account, and prepared client-ready invoices. We also assisted in hiring their first 3 employees compliantly through our HR partner network.",
        result:"The client acquired their first Indian customer within 6 weeks of engagement and expanded into Bangalore with a hybrid team."
    },
    {
        id:"2",
        image:cases2,
        name:'MedTech Firm from Dubai',
        title:'Onboarding',
        background:"A fast-growing MedTech firm operating in the UAE planned to offer diagnostic AI tools to Indian hospitals.",
        challenge:"Needed local compliance support, including HIPAA-like data safeguards, as well as help onboarding Indian hospital clients.",
        solution:"POC facilitated legal and tax structuring, assisted in building a compliant tech onboarding flow via Minmini, and supported them with invoicing, contracts, and onboarding scripts. We also deployed a prototype AI agent to help triage patient data into localized formats for review.",
        result:"Client onboarded 3 Indian hospitals in the first quarter, achieved 4x lead conversion compared to prior efforts, and built a sustainable India-side revenue channel."
    },
 ]